if (!customElements.get("variant-select-picker")) {
  customElements.define(
    "variant-select-picker",
    class VariantSelects extends HTMLElement {
      pickerDom = null;
      dropdownDom = null;
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "variant-selects select option[selected], variant-selects fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      connectedCallback() {
        this.pickerDom = this.querySelector(".variant-select-picker");
        this.dropdownDom = this.querySelector(".picker-options-dropdown");
        this.pickerDom.addEventListener("click", this.toggleDropdown);
        window.addEventListener("click", this.clickOtherToClose);
        this.dropdownDom.addEventListener("click", this.dropdownSelect);

        this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.handleVariantChangeSync
        );

        requestAnimationFrame(() => this.syncFromVariantSelects());
      }

      disconnectedCallback() {
        window.removeEventListener("click", this.clickOtherToClose);
        this.variantChangeUnsubscriber?.();
      }

      handleVariantChangeSync = (event) => {
        const mainProductInfo =
          document.querySelector('main product-info[id^="MainProduct-"]') ||
          document.querySelector("main product-info") ||
          document.querySelector("product-info");
        if (
          mainProductInfo &&
          event.data?.sectionId &&
          event.data.sectionId !== mainProductInfo.dataset.section
        ) {
          return;
        }
        this.syncFromVariantSelects();
      };

      syncFromVariantSelects() {
        const variantSelects = this.closest("variant-selects");
        if (!variantSelects || !this.dropdownDom) return;

        const dropdownOptionIds = new Set(
          [...this.dropdownDom.querySelectorAll(".option[data-option-value-id]")].map(
            (option) => option.dataset.optionValueId
          )
        );

        let selectedInput = null;
        variantSelects
          .querySelectorAll("fieldset input[type='radio']:checked")
          .forEach((input) => {
            if (dropdownOptionIds.has(input.dataset.optionValueId)) {
              selectedInput = input;
            }
          });

        if (!selectedInput) return;

        const optionDom = this.dropdownDom.querySelector(
          `.option[data-option-value-id="${selectedInput.dataset.optionValueId}"]`
        );
        if (!optionDom) return;

        this.updateSelectedDisplay(optionDom, selectedInput);
      }

      updateSelectedDisplay(optionDom, sourceInput = null) {
        this.dropdownDom.querySelectorAll(".option").forEach((option) => {
          option.classList.toggle("selected", option === optionDom);
        });

        const valueInfo = this.querySelector(".value-info");
        const colorBlock = optionDom.querySelector(".color-block");
        const valueLabel = optionDom.querySelector(".value-label");
        const sourceSwatch = sourceInput
          ?.closest("label")
          ?.querySelector(".swatch-color");

        if (!valueInfo) return;

        const triggerSwatch = valueInfo.querySelector(".color-block");
        const triggerLabel = valueInfo.querySelector(".value-label");
        const swatchBackground =
          sourceSwatch?.style.getPropertyValue("--swatch-background") ||
          colorBlock?.style.getPropertyValue("--swatch-background");

        if (triggerSwatch && swatchBackground) {
          triggerSwatch.style.setProperty("--swatch-background", swatchBackground);
        }
        if (triggerLabel && valueLabel) {
          triggerLabel.textContent = valueLabel.textContent;
        }
      }

      findOptionDom = (dom, endDom) => {
        if (!dom || dom === endDom) return null;
        if (dom.classList.contains("option")) return dom;
        if (dom.parentElement) {
          return this.findOptionDom(dom.parentElement, endDom);
        }
        return null;
      };

      dropdownSelect = (event) => {
        event.stopPropagation();
        const target = event.target;
        const optionDom = this.findOptionDom(target, this.dropdownDom);
        if (!optionDom) return;

        const optionValueId = optionDom.dataset.optionValueId;
        if (!optionValueId) return;

        const variantSelects = this.closest("variant-selects");
        variantSelects
          ?.querySelectorAll(`input[data-option-value-id="${optionValueId}"]`)
          .forEach((input) => {
            if (!input.disabled && !input.classList.contains("disabled")) {
              input.checked = true;
            }
          });

        this.dropdownDom.querySelectorAll(".option").forEach((option) => {
          option.classList.toggle("selected", option === optionDom);
        });

        this.updateSelectedDisplay(optionDom);

        this.pickerDom.classList.remove("expended");

        FoxTheme.pubsub.publish(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          {
            data: {
              event: { target: variantSelects || this },
              target: optionDom,
              selectedOptionValues: variantSelects?.selectedOptionValues || [optionValueId],
              from: "variantSelectPicker",
            },
          }
        );
      };

      clickOtherToClose = (e) => {
        const target = e.target;
        if (!this.contains(target)) {
          const isExpend = this.pickerDom.classList.contains("expended");
          if (isExpend) {
            this.pickerDom.classList.remove("expended");
          }
        }
      };

      scrollToSelectedOption = () => {
        const optionDom = this.dropdownDom.querySelector(".option.selected");
        if (!optionDom) return;
        const dropdownDomRect = this.dropdownDom.getBoundingClientRect(),
          optionRect = optionDom.getBoundingClientRect();
        if (dropdownDomRect.bottom < optionRect.bottom) {
          this.dropdownDom.scrollTop +=
            optionRect.bottom - dropdownDomRect.bottom + optionRect.height;
        } else if (dropdownDomRect.top > optionRect.top) {
          this.dropdownDom.scrollTop +=
            dropdownDomRect.top - dropdownDomRect.top + optionRect.height;
        }
      };

      toggleDropdown = (e) => {
        // Find Shade 入口在下拉框内，点击时不要展开/收起 Colour
        if (e?.target?.closest?.("tp-find-shade, [data-find-shade-open]")) {
          return;
        }
        const isExpend = this.pickerDom.classList.contains("expended");
        if (isExpend) {
          this.pickerDom.classList.remove("expended");
        } else {
          this.pickerDom.classList.add("expended");
          setTimeout(() => {
            this.scrollToSelectedOption();
          });
        }
      };
    }
  );
}
